import { Injectable } from '@angular/core';
import {
  CanActivate,
  UrlTree,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../services/profile/profile.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard implements CanActivate {
  constructor(private profileSrvc: ProfileService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise(async (resolve) => {
      const user = await this.profileSrvc.getCurrentUserProfile();
      const queryParams = { next: state.url };

      if (
        user.general_parental_consent_required &&
        !user.parent?.general_consent_accepted
      ) {
        this.router.navigate(['parental-consent'], { queryParams });
        resolve(false);
      } else if (!user.profile) {
        this.router.navigate(['tabs/profile/edit'], { queryParams });
        resolve(false);
      }

      resolve(true);
    });
  }
}
